/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantItemDto } from './tenantItemDto';
import { BuildingBaseData } from './buildingBaseData';


export interface BuildingApplicationItemDto { 
    id: string;
    baseData: BuildingBaseData;
    ownerTenant: TenantItemDto;
    applicationCreatorName: string;
    status: BuildingApplicationItemDto.StatusEnum;
    rejectComment?: string;
}
export namespace BuildingApplicationItemDto {
    export type StatusEnum = 'PENDING' | 'ACCEPTED' | 'REJECTED';
    export const StatusEnum = {
        Pending: 'PENDING' as StatusEnum,
        Accepted: 'ACCEPTED' as StatusEnum,
        Rejected: 'REJECTED' as StatusEnum
    };
}


